/* The Antique Parlour — Favorites engine v1.6
   Pairs with snippets/parlour-wishlist-core.liquid (config + styles)
   and the parlour-wishlist Cloudflare Worker (sync + share + adore).
   localStorage is the source of truth; all network calls fail soft.
   Share/hint links always use CFG.shareOrigin. v1.2: drawer.
   v1.6: the fav-unit box is retired — the save button stands alone
   with its own border, and beneath it one centered editorial line
   (pw-meta-line) holds the adored note and Drop a Hint side by side,
   both italic serif in antique gold with small icons, separated by a
   gold four-pointed star (CSS). Styling lives in core v1.7. */
(function () {
  'use strict';

  var CFG = window.ParlourWishlist || {};
  var KEY = 'parlourFavorites';
  var SHARE_KEY = 'parlourFavoritesShare';
  var HEART = 'M51.27 15.05a13 13 0 0 0-18.44 0l-.83.83-.83-.83a13 13 0 0 0-18.44 18.44l.83.83L32 52.77l18.44-18.45.83-.83a13 13 0 0 0 0-18.44z';
  var MAIL = '<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true" focusable="false"><rect x="2.5" y="5" width="19" height="14" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M3 6.2L12 13l9-6.8" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
  var ADORE_MIN = 3;

  function shareLink(sid) {
    return (CFG.shareOrigin || location.origin) + (CFG.favoritesUrl || '/pages/favorites') + '?shared=' + sid;
  }

  /* ---------------- store ---------------- */

  function loadState() {
    try {
      var raw = localStorage.getItem(KEY);
      if (raw) {
        var d = JSON.parse(raw);
        if (d && d.v === 1 && Array.isArray(d.items)) return d;
      }
    } catch (e) {}
    return { v: 1, items: [], updated: 0 };
  }

  var state = loadState();

  function persist(sync) {
    state.updated = Date.now();
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
    paint();
    if (sync !== false) queueSync();
  }

  function has(h) {
    for (var i = 0; i < state.items.length; i++) if (state.items[i].h === h) return true;
    return false;
  }

  function itemFrom(el) {
    var h = el.getAttribute('data-pw-handle');
    return {
      h: h,
      id: el.getAttribute('data-pw-id') || '',
      t: el.getAttribute('data-pw-title') || '',
      p: parseInt(el.getAttribute('data-pw-price'), 10) || 0,
      u: el.getAttribute('data-pw-url') || ('/products/' + h),
      img: el.getAttribute('data-pw-image') || '',
      at: Date.now()
    };
  }

  function toggleFrom(el) {
    var h = el.getAttribute('data-pw-handle');
    if (!h) return;
    if (has(h)) {
      state.items = state.items.filter(function (i) { return i.h !== h; });
    } else {
      state.items.unshift(itemFrom(el));
      el.classList.add('pw-pop');
      el.classList.add('pw-flash');
      setTimeout(function () { el.classList.remove('pw-pop'); }, 420);
      setTimeout(function () { el.classList.remove('pw-flash'); }, 920);
      adoreBump(h);
    }
    persist();
  }

  function mergeItems(a, b) {
    var map = {};
    a.concat(b).forEach(function (i) {
      if (!i || !i.h) return;
      if (!map[i.h] || (i.at || 0) > (map[i.h].at || 0)) map[i.h] = i;
    });
    return Object.keys(map).map(function (k) { return map[k]; })
      .sort(function (x, y) { return (y.at || 0) - (x.at || 0); });
  }

  /* ---------------- money ---------------- */

  function comma(s) {
    return String(s).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';
    var val = cents / 100;
    return fmt
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(val)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, val.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, comma(Math.round(val)))
      .replace(/\{\{\s*amount\s*\}\}/g, comma(val.toFixed(2)))
      .replace(/<[^>]*>/g, '');
  }

  /* ---------------- sync (signed-in customers) ---------------- */

  var syncTimer = null;

  function canSync() { return !!(CFG.cid && CFG.sig && CFG.workerUrl); }

  function queueSync() {
    if (!canSync()) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(pushSync, 1200);
  }

  function pushSync() {
    if (!canSync()) return;
    fetch(CFG.workerUrl + '/list/' + CFG.cid + '?sig=' + encodeURIComponent(CFG.sig), {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: state.items, updated: state.updated })
    }).catch(function () {});
  }

  function pullSync(done) {
    if (!canSync()) { if (done) done(); return; }
    fetch(CFG.workerUrl + '/list/' + CFG.cid + '?sig=' + encodeURIComponent(CFG.sig))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (d && Array.isArray(d.items)) {
          var merged = mergeItems(d.items, state.items);
          var localChanged = JSON.stringify(merged) !== JSON.stringify(state.items);
          var serverChanged = JSON.stringify(merged) !== JSON.stringify(d.items);
          if (localChanged || serverChanged) {
            state.items = merged;
            persist(serverChanged);
          }
        }
      })
      .catch(function () {})
      .then(function () { if (done) done(); });
  }

  /* ---------------- adore counters (v1.1) ---------------- */

  var adoreCache = {};

  function adoreBump(h) {
    if (!CFG.workerUrl || !h) return;
    adoreCache[h] = (adoreCache[h] || 0) + 1;
    fetch(CFG.workerUrl + '/adore', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ h: h })
    }).catch(function () {});
  }

  function fetchAdore(handles, cb) {
    if (!CFG.workerUrl || !handles.length) { cb(adoreCache); return; }
    var need = [];
    for (var i = 0; i < handles.length; i++) if (!(handles[i] in adoreCache)) need.push(handles[i]);
    if (!need.length) { cb(adoreCache); return; }
    fetch(CFG.workerUrl + '/adore?h=' + encodeURIComponent(need.slice(0, 40).join(',')))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (d && d.counts) for (var k in d.counts) adoreCache[k] = d.counts[k];
        cb(adoreCache);
      })
      .catch(function () { cb(adoreCache); });
  }

  /* product-page meta line: adored note + Drop a Hint share one
     centered editorial line beneath the save button (v1.6) */
  function ensureMetaLine(saveBtn) {
    var host = saveBtn.parentNode;
    if (!host) return null;
    var line = host.querySelector('.pw-meta-line');
    if (!line) {
      line = document.createElement('div');
      line.className = 'pw-meta-line';
      host.insertBefore(line, saveBtn.nextSibling);
    }
    var hint = host.querySelector('.pw-hint--product');
    if (hint && hint.parentNode !== line) {
      if (!hint.querySelector('svg')) {
        var lbl = hint.textContent.replace(/^\s+|\s+$/g, '');
        hint.innerHTML = MAIL + '<span data-pw-hint-label>' + esc(lbl) + '</span>';
      }
      line.appendChild(hint);
    }
    return line;
  }

  function annotate() {
    var els = document.querySelectorAll('[data-pw-toggle][data-pw-handle]');
    if (!els.length) return;
    var handles = [], seen = {};
    for (var i = 0; i < els.length; i++) {
      if (els[i].classList.contains('pw-product-save')) ensureMetaLine(els[i]);
      var h = els[i].getAttribute('data-pw-handle');
      if (h && !seen[h]) { seen[h] = 1; handles.push(h); }
    }
    fetchAdore(handles, function (counts) {
      for (var j = 0; j < els.length; j++) {
        var el = els[j];
        var hh = el.getAttribute('data-pw-handle');
        var n = counts[hh] || 0;
        if (n < ADORE_MIN) continue;
        if (el.classList.contains('pw-card-heart')) {
          var host = el.parentNode;
          if (host && !host.querySelector('.pw-adored-chip')) {
            var chip = document.createElement('div');
            chip.className = 'pw-adored-chip';
            chip.textContent = 'Adored by ' + n;
            host.appendChild(chip);
          }
        } else if (el.classList.contains('pw-product-save')) {
          var line = ensureMetaLine(el);
          if (line && !line.querySelector('.pw-adored-note')) {
            var note = document.createElement('span');
            note.className = 'pw-adored-note';
            note.innerHTML = heartSvg(11, 5) + '<span>Adored by ' + n + ' admirers</span>';
            line.insertBefore(note, line.firstChild);
          }
        }
      }
    });
  }

  /* ---------------- painting ---------------- */

  var lastCount = -1;

  function paint() {
    var n = state.items.length;
    var counts = document.querySelectorAll('[data-pw-count]');
    for (var i = 0; i < counts.length; i++) {
      counts[i].textContent = n;
      counts[i].style.display = n > 0 ? '' : 'none';
      if (lastCount !== -1 && n !== lastCount) {
        (function (el) {
          el.classList.add('pw-pulse');
          setTimeout(function () { el.classList.remove('pw-pulse'); }, 520);
        })(counts[i]);
      }
    }
    lastCount = n;
    var toggles = document.querySelectorAll('[data-pw-toggle]');
    for (var j = 0; j < toggles.length; j++) {
      var btn = toggles[j];
      var saved = has(btn.getAttribute('data-pw-handle'));
      btn.classList.toggle('pw-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      var lab = btn.querySelector('[data-pw-label]');
      if (lab) lab.textContent = saved ? 'Saved to Your Favorites' : 'Save to Your Favorites';
    }
  }

  /* ---------------- utilities ---------------- */

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function heartSvg(size, stroke) {
    return '<svg viewBox="0 0 64 64" width="' + size + '" height="' + size + '" aria-hidden="true" focusable="false">' +
      '<path d="' + HEART + '" fill="none" stroke="currentColor" stroke-width="' + (stroke || 4.5) + '" stroke-linejoin="round"/></svg>';
  }

  function copyText(txt) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(txt).catch(function () { legacyCopy(txt); });
    } else {
      legacyCopy(txt);
    }
  }

  function legacyCopy(txt) {
    var i = document.createElement('input');
    i.value = txt;
    i.style.position = 'fixed';
    i.style.opacity = '0';
    document.body.appendChild(i);
    i.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(i);
  }

  function skeletonHtml(n) {
    var s = '<div class="pw-grid pw-skel-grid">';
    for (var i = 0; i < n; i++) {
      s += '<div class="pw-card pw-skel"><div class="pw-skel-media"></div><div class="pw-card-body"><div class="pw-skel-line"></div><div class="pw-skel-line pw-skel-line--short"></div></div></div>';
    }
    return s + '</div>';
  }

  function fetchProducts(items, cb) {
    var out = {}, idx = 0, active = 0;
    function step() {
      if (idx >= items.length && active === 0) { cb(out); return; }
      while (active < 6 && idx < items.length) {
        (function (it) {
          active++;
          fetch('/products/' + encodeURIComponent(it.h) + '.js')
            .then(function (r) { if (!r.ok) throw r.status; return r.json(); })
            .then(function (p) { out[it.h] = { ok: true, p: p }; })
            .catch(function (err) { out[it.h] = { ok: false, gone: err === 404 }; })
            .then(function () { active--; step(); });
        })(items[idx]);
        idx++;
      }
    }
    if (!items.length) { cb(out); return; }
    step();
  }

  function firstAvailableVariant(p) {
    if (!p || !p.variants) return null;
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i];
    return null;
  }

  /* ---------------- favorites drawer (v1.2) ---------------- */

  var drawerEl = null, veilEl = null, drawerOpen = false;

  function buildDrawer() {
    if (drawerEl) return;
    veilEl = document.createElement('div');
    veilEl.className = 'pw-drawer-veil';
    veilEl.addEventListener('click', closeDrawer);
    drawerEl = document.createElement('aside');
    drawerEl.className = 'pw-drawer';
    drawerEl.setAttribute('role', 'dialog');
    drawerEl.setAttribute('aria-label', 'Your Favorites');
    document.body.appendChild(veilEl);
    document.body.appendChild(drawerEl);
    document.addEventListener('keydown', function (e) {
      if (drawerOpen && (e.key === 'Escape' || e.keyCode === 27)) closeDrawer();
    });
  }

  function drawerItemHtml(it) {
    var url = esc(it.u || '/products/' + it.h);
    return '<div class="pw-drawer-item" data-pw-card="' + esc(it.h) + '">' +
      '<a class="pw-drawer-thumb" href="' + url + '">' +
      (it.img ? '<img src="' + esc(it.img) + '" alt="' + esc(it.t) + '" loading="lazy">' : heartSvg(22, 3.5)) +
      '</a>' +
      '<div class="pw-drawer-info">' +
      '<a class="pw-drawer-title" href="' + url + '">' + esc(it.t) + '</a>' +
      (it.p ? '<div class="pw-drawer-price">' + formatMoney(it.p) + '</div>' : '') +
      '</div>' +
      '<button type="button" class="pw-remove pw-drawer-remove" data-pw-remove="' + esc(it.h) + '" aria-label="Remove from favorites">&times;</button>' +
      '</div>';
  }

  function renderDrawer() {
    if (!drawerEl) return;
    var items = state.items;
    var html = '<div class="pw-drawer-head">' +
      '<div class="pw-drawer-heading">' + heartSvg(15, 5) + '<span>Your Favorites</span></div>' +
      '<button type="button" class="pw-drawer-close" data-pw-drawer-close aria-label="Close">&times;</button>' +
      '</div>';
    if (!items.length) {
      html += '<div class="pw-drawer-empty">' +
        '<div class="pw-empty-heart">' + heartSvg(36, 3.5) + '</div>' +
        '<p class="pw-empty-text">Nothing kept yet. When a piece catches your eye, touch the heart and it will wait for you here.</p>' +
        '</div>';
    } else {
      html += '<div class="pw-drawer-list">';
      for (var i = 0; i < items.length; i++) html += drawerItemHtml(items[i]);
      html += '</div>';
    }
    html += '<div class="pw-drawer-foot">' +
      '<a class="pw-btn pw-btn-solid pw-drawer-cta" href="' + esc(CFG.favoritesUrl || '/pages/favorites') + '">View Your Favorites Page</a>' +
      (items.length ? '<div class="pw-drawer-note">Availability, sharing, and hints live on the full page.</div>' : '') +
      '</div>';
    drawerEl.innerHTML = html;
  }

  function openDrawer() {
    buildDrawer();
    renderDrawer();
    drawerOpen = true;
    drawerEl.classList.add('pw-open');
    veilEl.classList.add('pw-open');
    document.documentElement.classList.add('pw-no-scroll');
    var cl = drawerEl.querySelector('[data-pw-drawer-close]');
    if (cl) cl.focus();
  }

  function closeDrawer() {
    if (!drawerEl) return;
    drawerOpen = false;
    drawerEl.classList.remove('pw-open');
    veilEl.classList.remove('pw-open');
    document.documentElement.classList.remove('pw-no-scroll');
  }

  /* ---------------- favorites page ---------------- */

  var pageEl = null;
  var sortMode = 'recent';

  function classify(items, data) {
    var live = [], archived = [];
    items.forEach(function (it) {
      var d = data[it.h];
      if (d && d.ok && d.p && d.p.available) live.push({ it: it, p: d.p });
      else archived.push({ it: it, p: d && d.ok ? d.p : null, gone: !!(d && d.gone) });
    });
    return { live: live, archived: archived };
  }

  function applySort(arr) {
    var a = arr.slice();
    if (sortMode === 'asc') a.sort(function (x, y) { return curPrice(x) - curPrice(y); });
    else if (sortMode === 'desc') a.sort(function (x, y) { return curPrice(y) - curPrice(x); });
    else a.sort(function (x, y) { return (y.it.at || 0) - (x.it.at || 0); });
    return a;
  }

  function curPrice(row) { return row.p ? row.p.price : (row.it.p || 0); }

  function cardHtml(row, opts) {
    var it = row.it, p = row.p;
    var url = esc(it.u || '/products/' + it.h);
    var img = p && p.featured_image ? p.featured_image : it.img;
    var title = p ? p.title : it.t;
    var archived = !!opts.archived;
    var html = '<div class="pw-card' + (archived ? ' pw-card--archived' : '') + '" data-pw-card="' + esc(it.h) + '">';
    html += '<a class="pw-card-media" href="' + url + '">';
    if (img) html += '<img src="' + esc(img) + '" alt="' + esc(title) + '" loading="lazy">';
    else html += '<div class="pw-card-noimg">' + heartSvg(34, 3.5) + '</div>';
    if (archived) {
      html += '<div class="pw-card-veil"><span>' + (opts.gone ? 'No Longer Listed' : 'Now in The Archive') + '</span></div>';
    }
    html += '</a>';
    html += '<div class="pw-card-body">';
    html += '<a class="pw-card-title" href="' + url + '">' + esc(title) + '</a>';
    if (archived) {
      html += '<div class="pw-card-price"><span class="pw-sold">Sold</span></div>';
    } else {
      var cur = p.price, was = it.p || 0;
      if (was > 0 && cur < was) {
        html += '<div class="pw-card-price"><span class="pw-was">' + formatMoney(was) + '</span>' + formatMoney(cur) + '</div>';
        html += '<div class="pw-drop-note">The price has softened since you saved this piece.</div>';
      } else {
        html += '<div class="pw-card-price">' + formatMoney(cur) + '</div>';
      }
    }
    html += '<div class="pw-card-actions">';
    if (!archived) {
      var v = firstAvailableVariant(p);
      if (v) html += '<button type="button" class="pw-btn pw-btn-solid" data-pw-add="' + v.id + '">Add to Cart</button>';
    } else {
      html += '<a class="pw-btn pw-btn-outline" href="' + url + '">View</a>';
    }
    if (!opts.shared) html += '<button type="button" class="pw-remove" data-pw-remove="' + esc(it.h) + '">Remove</button>';
    html += '</div>';
    if (!archived && !opts.shared && CFG.workerUrl) {
      html += '<button type="button" class="pw-hint" data-pw-hint="' + esc(it.h) + '">' + MAIL + '<span data-pw-hint-label>Drop a Hint</span></button>';
    }
    if (archived && !opts.shared) {
      html += '<a class="pw-enquire" href="' + esc(CFG.contactUrl || '/pages/contact-us') + '">Enquire about similar pieces</a>';
    }
    html += '</div></div>';
    return html;
  }

  function shareRecord() {
    try {
      var raw = localStorage.getItem(SHARE_KEY);
      if (raw) { var d = JSON.parse(raw); if (d && d.id && d.token) return d; }
    } catch (e) {}
    return null;
  }

  function sharePanelHtml() {
    var rec = shareRecord();
    var html = '<div class="pw-share-panel" data-pw-share-panel>';
    if (rec && CFG.workerUrl) {
      var link = shareLink(rec.id);
      html += '<div class="pw-share-inner">' +
        '<div class="pw-share-lede">Your favorites have a private link — anyone who holds it may view the list.</div>' +
        '<div class="pw-share-row">' +
        '<input class="pw-share-url" type="text" readonly value="' + esc(link) + '" data-pw-share-url>' +
        '<button type="button" class="pw-btn pw-btn-solid" data-pw-copy>Copy Link</button>' +
        '</div>' +
        '<button type="button" class="pw-revoke" data-pw-revoke>Withdraw this link</button>' +
        '</div>';
    }
    html += '</div>';
    return html;
  }

  function renderMine(container) {
    var items = state.items;
    if (!items.length) {
      container.innerHTML =
        '<div class="pw-empty">' +
        '<div class="pw-empty-heart">' + heartSvg(44, 3.5) + '</div>' +
        '<h2 class="pw-empty-title">Nothing kept yet</h2>' +
        '<p class="pw-empty-text">When a piece catches your eye, touch the heart and it will wait for you here.</p>' +
        '<a class="pw-btn pw-btn-solid" href="/collections/all">Explore the Collection</a>' +
        '</div>';
      return;
    }
    container.innerHTML = skeletonHtml(Math.min(items.length, 8));
    fetchProducts(items, function (data) {
      var groups = classify(items, data);
      var live = applySort(groups.live);
      var archived = applySort(groups.archived);
      var html = '';
      html += '<div class="pw-toolbar">' +
        '<div class="pw-count">' + items.length + (items.length === 1 ? ' piece kept' : ' pieces kept') + '</div>' +
        '<div class="pw-tools">' +
        '<select class="pw-sort" data-pw-sort aria-label="Sort favorites">' +
        '<option value="recent"' + (sortMode === 'recent' ? ' selected' : '') + '>Recently added</option>' +
        '<option value="asc"' + (sortMode === 'asc' ? ' selected' : '') + '>Price: low to high</option>' +
        '<option value="desc"' + (sortMode === 'desc' ? ' selected' : '') + '>Price: high to low</option>' +
        '</select>' +
        (CFG.workerUrl ? '<button type="button" class="pw-btn pw-btn-outline" data-pw-share>Share Your List</button>' : '') +
        '</div></div>';
      html += sharePanelHtml();
      html += '<div class="pw-grid">';
      live.forEach(function (row) { html += cardHtml(row, { archived: false, shared: false }); });
      html += '</div>';
      if (!live.length) {
        html += '<p class="pw-empty-text" style="text-align:center;">Every piece you kept has since found a home &mdash; such is the way of one-of-a-kind treasures.</p>';
      }
      if (archived.length) {
        html += '<div class="pw-archive-band">' +
          '<h2 class="pw-archive-title">Since spoken for</h2>' +
          '<div class="pw-grid">';
        archived.forEach(function (row) { html += cardHtml(row, { archived: true, gone: row.gone, shared: false }); });
        html += '</div></div>';
      }
      container.innerHTML = html;
    });
  }

  function renderShared(container, sid) {
    if (!CFG.workerUrl) { renderMine(container); return; }
    container.innerHTML = '<p class="pw-share-status" style="text-align:center;">Opening the shared list&hellip;</p>';
    fetch(CFG.workerUrl + '/share/' + encodeURIComponent(sid))
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (d) {
        var items = (d && d.items) || [];
        container.innerHTML = skeletonHtml(Math.min(items.length || 1, 4));
        fetchProducts(items, function (data) {
          var groups = classify(items, data);
          var bannerText = d.hint
            ? 'Someone you love has been admiring this piece at The Antique Parlour'
            : 'A list shared with you from The Antique Parlour';
          var html = '<div class="pw-shared-banner">' + bannerText + '</div>';
          html += '<div class="pw-grid">';
          applySort(groups.live).forEach(function (row) { html += cardHtml(row, { archived: false, shared: true }); });
          applySort(groups.archived).forEach(function (row) { html += cardHtml(row, { archived: true, gone: row.gone, shared: true }); });
          html += '</div>';
          html += '<div class="pw-shared-footer"><button type="button" class="pw-btn pw-btn-outline" data-pw-keep>Keep These in My Favorites</button></div>';
          container.innerHTML = html;
          var keep = container.querySelector('[data-pw-keep]');
          if (keep) keep.addEventListener('click', function () {
            state.items = mergeItems(state.items, items.map(function (i) { i.at = i.at || Date.now(); return i; }));
            persist();
            location.href = (CFG.favoritesUrl || '/pages/favorites');
          });
        });
      })
      .catch(function () {
        container.innerHTML = '<p class="pw-empty-text" style="text-align:center;">This shared list has expired or been withdrawn.</p>' +
          '<div class="pw-shared-footer"><a class="pw-btn pw-btn-solid" href="/collections/all">Explore the Collection</a></div>';
      });
  }

  function createShare(btn) {
    btn.disabled = true;
    btn.textContent = 'Preparing\u2026';
    fetch(CFG.workerUrl + '/share', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: state.items })
    })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (d) {
        try { localStorage.setItem(SHARE_KEY, JSON.stringify({ id: d.id, token: d.token })); } catch (e) {}
        refreshPage();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Share Your List';
      });
  }

  function hintPanel(btn, link) {
    var host = btn.parentNode;
    if (!host) return;
    var existing = host.querySelector('.pw-hint-panel');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
    var wrap = document.createElement('div');
    wrap.className = 'pw-hint-panel';
    wrap.innerHTML = '<input class="pw-share-url" type="text" readonly value="' + esc(link) + '" data-pw-hint-url>' +
      '<button type="button" class="pw-btn pw-btn-solid" data-pw-copy-hint>Copy</button>';
    host.insertBefore(wrap, btn.nextSibling);
  }

  function dropHint(btn) {
    if (!CFG.workerUrl) return;
    var h = btn.getAttribute('data-pw-hint');
    if (!h) return;
    var item = null;
    for (var i = 0; i < state.items.length; i++) if (state.items[i].h === h) { item = state.items[i]; break; }
    if (!item) {
      var src = document.querySelector('[data-pw-toggle][data-pw-handle="' + h + '"]');
      if (src) item = itemFrom(src);
    }
    if (!item) return;
    var labEl = btn.querySelector('[data-pw-hint-label]');
    function setLab(t) { if (labEl) labEl.textContent = t; else btn.textContent = t; }
    var old = labEl ? labEl.textContent : btn.textContent;
    btn.disabled = true;
    setLab('Preparing\u2026');
    fetch(CFG.workerUrl + '/share', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item], hint: 1 })
    })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (d) {
        var link = shareLink(d.id);
        copyText(link);
        hintPanel(btn, link);
        btn.disabled = false;
        setLab('Your hint link \u2193');
        setTimeout(function () { setLab(old); }, 2600);
      })
      .catch(function () {
        btn.disabled = false;
        setLab(old);
      });
  }

  function revokeShare() {
    var rec = shareRecord();
    if (!rec) return;
    fetch(CFG.workerUrl + '/share/' + rec.id + '?token=' + encodeURIComponent(rec.token), { method: 'DELETE' }).catch(function () {});
    try { localStorage.removeItem(SHARE_KEY); } catch (e) {}
    refreshPage();
  }

  function addToCart(btn) {
    var vid = parseInt(btn.getAttribute('data-pw-add'), 10);
    if (!vid) return;
    btn.disabled = true;
    btn.textContent = 'Adding\u2026';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () {
        var a = document.createElement('a');
        a.className = 'pw-btn pw-btn-solid';
        a.href = '/cart';
        a.textContent = 'In Your Cart \u2014 View';
        btn.parentNode.replaceChild(a, btn);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      });
  }

  function refreshPage() {
    if (!pageEl) return;
    var sid = new URLSearchParams(location.search).get('shared');
    if (sid) renderShared(pageEl, sid);
    else renderMine(pageEl);
  }

  /* ---------------- wiring ---------------- */

  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('.pw-header-link'))) {
      if (!pageEl) { e.preventDefault(); e.stopPropagation(); openDrawer(); }
      return;
    }
    if ((t = e.target.closest('[data-pw-drawer-close]'))) { closeDrawer(); return; }
    if ((t = e.target.closest('[data-pw-toggle]'))) { e.preventDefault(); e.stopPropagation(); toggleFrom(t); return; }
    if ((t = e.target.closest('[data-pw-remove]'))) {
      var h = t.getAttribute('data-pw-remove');
      state.items = state.items.filter(function (i) { return i.h !== h; });
      persist();
      var card = t.closest('[data-pw-card]');
      if (card) card.remove();
      if (drawerOpen) renderDrawer();
      if (!state.items.length) refreshPage();
      return;
    }
    if ((t = e.target.closest('[data-pw-add]'))) { addToCart(t); return; }
    if ((t = e.target.closest('[data-pw-hint]'))) { e.preventDefault(); e.stopPropagation(); dropHint(t); return; }
    if ((t = e.target.closest('[data-pw-copy-hint]'))) {
      e.preventDefault();
      e.stopPropagation();
      var hostWrap = t.parentNode;
      var hintInput = hostWrap && hostWrap.querySelector('[data-pw-hint-url]');
      if (!hintInput) return;
      hintInput.select();
      hintInput.setSelectionRange(0, 9999);
      var hintCopyBtn = t;
      function hintCopied() { hintCopyBtn.textContent = 'Copied \u2713'; setTimeout(function () { hintCopyBtn.textContent = 'Copy'; }, 1800); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(hintInput.value).then(hintCopied, function () { document.execCommand('copy'); hintCopied(); });
      else { document.execCommand('copy'); hintCopied(); }
      return;
    }
    if ((t = e.target.closest('[data-pw-share]'))) { createShare(t); return; }
    if ((t = e.target.closest('[data-pw-revoke]'))) { revokeShare(); return; }
    if ((t = e.target.closest('[data-pw-copy]'))) {
      var input = document.querySelector('[data-pw-share-url]');
      if (!input) return;
      input.select();
      input.setSelectionRange(0, 9999);
      var copyBtn = t;
      function copied() { copyBtn.textContent = 'Copied \u2713'; setTimeout(function () { copyBtn.textContent = 'Copy Link'; }, 1800); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(input.value).then(copied, function () { document.execCommand('copy'); copied(); });
      else { document.execCommand('copy'); copied(); }
      return;
    }
  }, true);

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-pw-sort]');
    if (!sel) return;
    sortMode = sel.value;
    refreshPage();
  });

  /* repaint + annotate hearts that arrive via AJAX (quick-shop, filtered collections) */
  var moTimer = null;
  function watchNewHearts() {
    if (!window.MutationObserver) return;
    new MutationObserver(function (muts) {
      var hit = false;
      for (var i = 0; i < muts.length && !hit; i++) {
        var m = muts[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var nd = m.addedNodes[j];
          if (nd.nodeType === 1 && ((nd.hasAttribute && nd.hasAttribute('data-pw-toggle')) || (nd.querySelector && nd.querySelector('[data-pw-toggle]')))) { hit = true; break; }
        }
      }
      if (!hit) return;
      clearTimeout(moTimer);
      moTimer = setTimeout(function () { paint(); annotate(); }, 300);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    var st = document.createElement('style');
    st.textContent = '[data-pw-toggle].pw-saved svg path{fill:currentColor;}';
    document.head.appendChild(st);
    paint();
    annotate();
    watchNewHearts();
    pageEl = document.getElementById('ParlourFavorites');
    var sid = pageEl ? new URLSearchParams(location.search).get('shared') : null;
    if (pageEl && sid) {
      renderShared(pageEl, sid);
      pullSync();
    } else if (pageEl) {
      /* on the favorites page, wait briefly for sync so signed-in customers see their full list */
      pullSync(function () { refreshPage(); });
    } else {
      pullSync();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
